/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BillingChangePreviewRequestAction } from './billingChangePreviewRequestAction';
import type { BillingChangePreviewRequestCadence } from './billingChangePreviewRequestCadence';
import type { BillingChangePreviewRequestPlanSlug } from './billingChangePreviewRequestPlanSlug';

export interface BillingChangePreviewRequest {
  action: BillingChangePreviewRequestAction;
  cadence?: BillingChangePreviewRequestCadence;
  seat_count?: number | null;
  plan_slug?: BillingChangePreviewRequestPlanSlug;
}
